//  home page collection-list slider
  
function initSliders() {
  var sliders = document.querySelectorAll('.brands_parts .collection-list__inner');

  sliders.forEach(function (slider) {
    if (!slider.classList.contains('flickity-enabled') && slider.offsetParent !== null) {
      var flkty = new Flickity(slider, {
        cellAlign: 'left',
        contain: true,
        pageDots: false
      });
      flkty.resize();
    }
  });

  if ([...sliders].every(s => s.classList.contains('flickity-enabled'))) {
    clearInterval(intervalId);
  }
}
document.addEventListener('shopify:section:load', initSliders);
document.addEventListener('DOMContentLoaded', initSliders);

var intervalId = setInterval(initSliders, 300);



